import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useGetPicture() {
  const { t } = useTranslation('exceptions')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const { authInfo } = useAuth()
  const { fetcher } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  /**
   * Without a profile id, returns the authenticated user's picture; with one, any user's picture (admin only).
   */
  const getPicture = async (
    profileId?: number | string
  ): Promise<Blob | null> => {
    setLoading(true)
    setError(null)

    try {
      const response = await fetcher<Response>(
        profileId === undefined
          ? `${CONFIG.BOUNCE_API}/api/v1/profile/picture`
          : `${CONFIG.BOUNCE_API}/api/v1/profiles/${encodeURIComponent(profileId)}/picture`
      )
      return response ? await response.blob() : null
    } catch (caughtError) {
      if (caughtError instanceof ApiError && caughtError.data.status === 404) {
        return null
      }

      console.error(caughtError)
      setError(
        caughtError instanceof ApiError
          ? getErrorMessage(caughtError.data)
          : t('exceptions:unknown')
      )
      return null
    } finally {
      setLoading(false)
    }
  }

  return { getPicture, loading, error }
}
